var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDangerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 15.2C10.7775 15.2 10.56 15.2659 10.375 15.3895C10.19 15.5132 10.0458 15.6889 9.96064 15.8944C9.87549 16.1 9.85321 16.3262 9.89662 16.5444C9.94003 16.7627 10.0472 16.9631 10.2045 17.1204C10.3618 17.2778 10.5623 17.3849 10.7805 17.4283C10.9988 17.4717 11.225 17.4495 11.4305 17.3643C11.6361 17.2792 11.8118 17.135 11.9354 16.95C12.059 16.765 12.125 16.5475 12.125 16.325C12.125 16.0266 12.0065 15.7404 11.7955 15.5295C11.5845 15.3185 11.2984 15.2 11 15.2Z",
    fill: "#E62E2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 6.94995H10.25V13.7H11.75V6.94995Z",
    fill: "#E62E2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 20.45H1.25001C1.12115 20.45 0.99447 20.4168 0.882175 20.3536C0.769881 20.2904 0.675763 20.1993 0.608894 20.0892C0.542026 19.979 0.504663 19.8535 0.500409 19.7247C0.496155 19.5959 0.525152 19.4682 0.584606 19.3539L10.3346 0.603912C10.3979 0.482138 10.4935 0.380077 10.6108 0.308847C10.7281 0.237618 10.8627 0.199951 11 0.199951C11.1373 0.199951 11.2719 0.237618 11.3892 0.308847C11.5065 0.380077 11.6021 0.482138 11.6654 0.603912L21.4154 19.3539C21.4749 19.4682 21.5039 19.5959 21.4996 19.7247C21.4953 19.8535 21.458 19.979 21.3911 20.0892C21.3242 20.1993 21.2301 20.2904 21.1178 20.3536C21.0055 20.4168 20.8789 20.45 20.75 20.45ZM2.48803 18.95H19.512L19.5135 18.9475L11.0015 2.57851H10.9985L2.48653 18.9475L2.48803 18.95Z",
    fill: "#E62E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerIcon);
export default __webpack_public_path__ + "static/media/dangerIcon.11bb57771200d9ec1f0ff5201c41e960.svg";
export { ForwardRef as ReactComponent };